// externals
import type { FC } from 'react';

// components
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

// hooks
import { useRetailPriceField } from './hooks/useRetailPriceField';

const RetailPriceField: FC = () => {
    const { label, inputProps } = useRetailPriceField();

    return <NumericInput label={label} {...inputProps} />;
};

export default RetailPriceField;
